import { FormattedText } from "@tm/static";
import {
  CalloutCta,
  CalloutIcon,
  CalloutText,
  CalloutWrapper,
} from "./MyCashCallout.styles";
import { IMyCashData, MyCashState } from "./types";

interface MyCashCalloutProps {
  myCashData?: IMyCashData;
  myCashState: MyCashState;
  onCtaClick?: () => void;
}

const MyCashCallout = ({
  myCashData,
  myCashState,
  onCtaClick,
}: MyCashCalloutProps) => {
  const stateData = myCashData?.[myCashState];
  if (!stateData?.title) return null;

  return (
    <CalloutWrapper>
      {stateData.icon && <CalloutIcon src={stateData.icon} alt="myCash" />}
      {stateData.title && (
        <CalloutText>
          <FormattedText value={stateData.title} />
        </CalloutText>
      )}
      {stateData.ctaText && (
        <CalloutCta onClick={onCtaClick}>{stateData.ctaText}</CalloutCta>
      )}
    </CalloutWrapper>
  );
};

export default MyCashCallout;
